<template>
    <div>
       <Head :title="__('Dashboard')" />
        
       <div class="bg-white p-4 rounded shadow-lg " >
           {{ __('Reports detail') }} {{ __('by') }} : <b>{{departmentname}}</b>
           <div class="w-full font-bold mt-6">{{ __('Filter selected') }} :</div>
           <div v-if="FilterSelect" class="flex flex-col gap-3 mb-4 py-3 md:flex-row w-full items-center">
                <div v-for="Filter in FilterSelect" class="w-full">
                    <div class="">{{ __(Filter.name)  }} : <span class="font-bold"> {{ Filter.value  }}</span></div>
                </div>
           </div>
       </div>

       <div class="p-2 mt-3 " >
           <b>Total de ticket(s) </b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbycategory" class="flex w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>

       <div class="p-2" >
           <b>Total de ticket(s) pendientes de cierre</b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbycategoryNotClose" class="flex   w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>
 
       <div class="p-2" >
           <b>Total de ticket(s) por prioridad(s)</b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbyPriority" class="flex   w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>

       <div class="p-2" >
           <b>Total de ticket(s) por prioridad(s) pendientes de cierre</b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbyPriorityNotClose" class="flex   w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>

       <div class="p-2" >
           <b>Total de ticket(s) por estado(s)</b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbyStatus" class="flex   w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>

       <div class="p-2" >
           <b>Total de ticket(s) por estado(s) pendientes de cierre</b>
           <div v-if="totalbycategory" class="flex flex-col gap-2 py-3 md:flex-row w-full items-center">
                <div v-for="category in totalbyStatusNotClose" class="flex   w-1/6 bg-white h-auto m-2 p-5 shadow  items-center justify-between">
                    <div class="flex"><b>{{ category.name }}</b></div>
                    <div class="flex font-bold text-[24px]">{{ category.cantidad }}</div>
                </div>                 
           </div>
       </div>
       

       

    </div>
 </template>
 <script>
 import Layout from '@/Shared/Layout'
 import {Head, Link} from '@inertiajs/inertia-vue3'
 import Icon from '@/Shared/Icon'
 import TextInput from '@/Shared/TextInput'
 import SearchInput from '@/Shared/SearchInput'
 import SelectInput from '@/Shared/SelectInput'
 import SelectInputFilter from '@/Shared/SelectInputFilter'
 import Pagination from '@/Shared/Pagination'
 import throttle from 'lodash/throttle'
   import pickBy from 'lodash/pickBy'
 export default {
   metaInfo: { title: 'Reports' },
   components: {
         SearchInput,
         Icon,
         Head,
         Link,
         TextInput,
         SelectInputFilter,
         SelectInput,
     },
   layout: Layout,
   props: {
            departmentname: String,
            filters : Object,
            FilterSelect : Object,
            totalbycategory : Object,
            totalbycategoryNotClose : Object,
            totalbyPriority : Object,
            totalbyPriorityNotClose : Object,
            totalbyStatus : Object,
            totalbyStatusNotClose : Object
     },
     created() {
          
     },
     data() {
         return {
             
         }
     }
 }
 </script>
 